module.exports = __webpack_public_path__ + "static/media/easySignLogo.b3862b39.svg";